<script>
import DatePicker from "../DatePicker/Datepicker";
import { serverBus } from "../../main";
import Icono from "../Icono/Icono";
import {
  actualizarMarcacionesProgramasPaciente,
  consultarNombresProgramas,
  crearNuevoPrograma,
  consultarMarcacionesProgramasPaciente,
  consultarNombresProgramasDisponibles
} from "../../apiService/request/CrudSeguimiento";

export default {
  data() {
    return {
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      crarProgramaEnabled: true,
      visibleNuevoPrograma: false,
      arrayNombresProgramas: [],
      color: "#3A6BE0",
      editable: true,
      date: new Date().toISOString().substr(0, 10),
      options: {
        locale: "es",
        format: "YYYY/MM/DD",
        clearable: true
      },
      deshabilitado: true,
      verComponente: "",
      arrayEditable: [],
      keyTarjeta: 0,
      arrayCopia:[],
      iconoVolver:
        "M33,44c-0.3,0-0.5-0.1-0.7-0.3l-22-21C10.1,22.5,10,22.3,10,22s0.1-0.5,0.3-0.7l22-21C32.6,0,33-0.1,33.4,0.1 C33.8,0.2,34,0.6,34,1v42c0,0.4-0.2,0.8-0.6,0.9C33.3,44,33.1,44,33,44z M12.4,22L32,40.7V3.3L12.4,22z M44,0v44 M0,0v44"
    };
  },
  mounted() {},
  beforeUpdate() {

  },
  created() {
    this.consultarNombresProgramasDisponibles();
  },
  
  props: {

    datosMarcacionesPrograma: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    datosMarcacionesPrograma: function (valor) {
      if (valor) {
        this.datosMarcacionesPrograma.map(Element => this.arrayEditable.push(true));
        this.arrayCopia = this.datosMarcacionesPrograma;
      }
    }
  },
  computed: {},
  methods: {

    variablesMarcaciones: function(variables) {
      const arrayActualizar = [];
      variables.map(datosVariables => {
        if (datosVariables.valor != null) {
          if (datosVariables.tipo == "fecha") {
            const jsonActualizar = {
              nombre: datosVariables.variable,
              valor: Number(datosVariables.valor)
            };
            arrayActualizar.push(jsonActualizar);
          } else {
            const jsonActualizar = {
              nombre: datosVariables.variable,
              valor: datosVariables.valor
            };
            arrayActualizar.push(jsonActualizar);
          }
        }
      });
      return arrayActualizar;
    },
    habilitarEdicionTarjeta(index) {
      this.arrayEditable[index] = !this.arrayEditable[index];
      this.keyTarjeta++;
    },
    async actualizarMarcacionesProgramasPaciente(valor, index) {
      // console.log("holadesde actualizar", this.variablesMarcaciones);
      try {
        this.$store.dispatch("setCargando", true);
        const respuesta = await actualizarMarcacionesProgramasPaciente(
          valor.docId,
          this.$store.state.provider_email,
          valor.key,
          this.variablesMarcaciones(valor.variables),
          "programas"
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
        console.log("datps hijo en padre", valor);
      } catch (error) {
        console.log("hola serror", error);
      } finally {
        this.habilitarEdicionTarjeta(index);
        this.$store.dispatch("setCargando", false);
        this.$emit("recargarMarcaciones")
      }
    },
    async consultarNombresProgramasDisponibles() {
      const respuesta = await consultarNombresProgramasDisponibles(
      this.$store.getters.getCedulaPaciente,
      );
      this.arrayNombresProgramas = respuesta.data.data.opciones;
      // this.visibleNuevoPrograma = true;
      // this.$emit("recargarMarcaciones")
    },
    // async consultarNombresProgramas() {
    //   const respuesta = await consultarNombresProgramas();
    //   console.log("nombre", respuesta.data.data);
    //   this.arrayNombresProgramas = respuesta.data.data.opciones;
    //   this.visibleNuevoPrograma = true;
    // },
    async crearNuevoPrograma(tipo_esquema, documento, creado_por) {
      this.$store.dispatch("setCargando", true);
      try {
        const respuesta = await crearNuevoPrograma(
          this.arrayNombresProgramas.nombre,
          this.$store.getters.getCedulaPaciente,
          this.$store.state.provider_email
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } catch (error) {
        console.log("hola error", error);
      } finally {
        this.arrayNombresProgramas.nombre = []
        this.$store.dispatch("setCargando", false);
        this.editable = true;
        this.crarProgramaEnabled = true;
        this.visibleNuevoPrograma = false;
        this.$emit("recargarMarcaciones")
      }
    }
  },
  components: {
    Icono,
    DatePicker
  }
};
</script>
<template src="./marcacionesPrograma.html"></template>
<style lang="scss" scoped src="./marcacionesPrograma.scss"></style>


// WEBPACK FOOTER //
// src/components/MarcacionesPrograma/marcacionesPrograma.vue